// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1Cv1v","emails":"CreateEditClinics_emails__30SXO","emailTagLabel":"CreateEditClinics_emailTagLabel__adOVJ"};